/**
 * @generated SignedSource<<70a78e24186b02ad3a525e6c20766666>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreatePaymentMethodSetupIntentInput = {
  customerAccountIdentifier: string;
};
export type SetUpStripePaymentMethodDialogCreateSetupIntentMutation$variables = {
  input: CreatePaymentMethodSetupIntentInput;
};
export type SetUpStripePaymentMethodDialogCreateSetupIntentMutation$data = {
  readonly createPaymentMethodSetupIntent: {
    readonly clientSecret: string;
    readonly id: string;
  };
};
export type SetUpStripePaymentMethodDialogCreateSetupIntentMutation = {
  response: SetUpStripePaymentMethodDialogCreateSetupIntentMutation$data;
  variables: SetUpStripePaymentMethodDialogCreateSetupIntentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PaymentMethodSetupIntent",
    "kind": "LinkedField",
    "name": "createPaymentMethodSetupIntent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientSecret",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetUpStripePaymentMethodDialogCreateSetupIntentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetUpStripePaymentMethodDialogCreateSetupIntentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0c2ec39390108cab1bf0036ace7a3ce",
    "id": null,
    "metadata": {},
    "name": "SetUpStripePaymentMethodDialogCreateSetupIntentMutation",
    "operationKind": "mutation",
    "text": "mutation SetUpStripePaymentMethodDialogCreateSetupIntentMutation(\n  $input: CreatePaymentMethodSetupIntentInput!\n) {\n  createPaymentMethodSetupIntent(input: $input) {\n    id\n    clientSecret\n  }\n}\n"
  }
};
})();

(node as any).hash = "b55783992ee91263d07e5284b3e06e21";

export default node;
